import { createClient } from 'contentful';
import { CONTENTFUL_API_KEY, CONTENTFUL_ENV, CONTENTFUL_SPACE_ID } from './appConfigs';

export const ContentfulClientConfigs = createClient({
      space: CONTENTFUL_SPACE_ID!,
      accessToken: CONTENTFUL_API_KEY!,
      environment: CONTENTFUL_ENV
    });
